import { useEffect } from "react";

import { getToken, setCookie } from "../../utils";

export const useToken = (token?: string): void => {
  useEffect(() => {
    const currentToken = token || getToken();
    if (currentToken) {
      setCookie(
        "X-Auth-Key", currentToken, {
          "secure": true,
          "max-age": 3600,
        },
      );
    }
  }, [ token ]);
};
